module.exports = __webpack_public_path__ + "img/hzzw-content.ce0743ec.png";